/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License. See License.txt in the project root for
 * license information.
 *
 * Code generated by Microsoft (R) AutoRest Code Generator.
 * Changes may cause incorrect behavior and will be lost if the code is
 * regenerated.
 */
export var acceptLanguage = {
    parameterPath: "acceptLanguage",
    mapper: {
        serializedName: "accept-language",
        defaultValue: 'en-US',
        type: {
            name: "String"
        }
    }
};
export var apiVersion = {
    parameterPath: "apiVersion",
    mapper: {
        required: true,
        serializedName: "api-version",
        type: {
            name: "String"
        }
    }
};
export var applicationID = {
    parameterPath: "applicationID",
    mapper: {
        required: true,
        serializedName: "applicationID",
        type: {
            name: "String"
        }
    }
};
export var applicationObjectId = {
    parameterPath: "applicationObjectId",
    mapper: {
        required: true,
        serializedName: "applicationObjectId",
        type: {
            name: "String"
        }
    }
};
export var domainName = {
    parameterPath: "domainName",
    mapper: {
        required: true,
        serializedName: "domainName",
        type: {
            name: "String"
        }
    }
};
export var filter = {
    parameterPath: [
        "options",
        "filter"
    ],
    mapper: {
        serializedName: "$filter",
        type: {
            name: "String"
        }
    }
};
export var groupObjectId = {
    parameterPath: "groupObjectId",
    mapper: {
        required: true,
        serializedName: "groupObjectId",
        type: {
            name: "String"
        }
    }
};
export var memberObjectId = {
    parameterPath: "memberObjectId",
    mapper: {
        required: true,
        serializedName: "memberObjectId",
        type: {
            name: "String"
        }
    }
};
export var nextLink = {
    parameterPath: "nextLink",
    mapper: {
        required: true,
        serializedName: "nextLink",
        type: {
            name: "String"
        }
    },
    skipEncoding: true
};
export var nextPageLink = {
    parameterPath: "nextPageLink",
    mapper: {
        required: true,
        serializedName: "nextLink",
        type: {
            name: "String"
        }
    },
    skipEncoding: true
};
export var objectId = {
    parameterPath: "objectId",
    mapper: {
        required: true,
        serializedName: "objectId",
        type: {
            name: "String"
        }
    }
};
export var ownerObjectId = {
    parameterPath: "ownerObjectId",
    mapper: {
        required: true,
        serializedName: "ownerObjectId",
        type: {
            name: "String"
        }
    }
};
export var tenantID = {
    parameterPath: "tenantID",
    mapper: {
        required: true,
        serializedName: "tenantID",
        type: {
            name: "String"
        }
    }
};
export var upnOrObjectId = {
    parameterPath: "upnOrObjectId",
    mapper: {
        required: true,
        serializedName: "upnOrObjectId",
        type: {
            name: "String"
        }
    }
};
//# sourceMappingURL=parameters.js.map